<template>
  <div class="listmain ">
    <div class="firTitle">技能开发常见问题</div>

    <div class="sedTitle">Q：在线测试回复“抱歉，技能正在学习中”</div>
    <p class="text20">
        1.请检查配置服务的地址是否正确配置并可以正常访问; <br>
        2.请稍等几分钟（最多10分钟），由于开发者技能较多，同步技能和训练模型需要一段时间。若10分钟后回复语句没有改变，请联系我们的开发QQ群，私信群主（技能QQ群号：702087131） <br>
    </p>
      <div class="sedTitle">Q：在线测试回复“抱歉，这个技能暂时无法使用”</div>
      <p class="text20">
          1.技能的“配置服务”未填写部署地址或者地址无法访问(报400~500错误)<br>
          2.技能的“配置服务”填写的部署地址无法接收到猎户语音OS的请求 <br>
          3.技能接收到猎户语音OS的请求后没有按照标准的响应协议进行响应，标准协议请参照语音OS技能的《服务请求与响应》
      </p>
      <div class="sedTitle">Q：如何使用技能</div>
      <p class="text20">
          开发者或者用户在使用技能时可以通过以下方式：<br>
          <span class="text20">
          1.open+技能名称：<br>
           open是指打开,开启,启动,使用等词语<br>
           如：打开万年历;<br>
           如：打开健康问答;<br>
          2.let+技能名称+intent：<br>
           let是指让,使等祈使词。<br>
           intent是指意图中的常用语句。<br>
           如：让万年历查一下今天的农历日期;<br>
           如：让健康问答查一下尿酸高怎么办？<br>
           PS: 在使用真机测试时，技能会一直处于对话流状态中，如果多次超时未回复或者多次未命中意图都会自动退出当前技能。
          </span>
      </p>
      <div class="sedTitle">Q：如何可以看到发布后的技能</div>
      <p class="text20 indent20">
          要实现技能在小豹音箱测试，首先需要通过开放平台审核通过。 审核通过后，小豹音箱运营会根据技能商店中的技能质量有选择的添加到音箱中供用户使用。 这意味着并不是所有通过审核的技能都可以在小豹音箱中使用并测试。 如果您的技能希望在小豹音箱使用，可以添加到技能开发QQ群，私信群主申请优化技能后上线到小豹音箱。
      </p>
      <div class="sedTitle">Q：发布到我的技能 = 私有化发布技能</div>
      <p class="text20 indent20">
          私有化发布技能是指仅供自己账号使用的技能，一般情况下仅支持自有硬件产品使用。在技能发布页面选择“发布到我的技能”即为私有化发布功能。
      </p>
      <div class="sedTitle">Q： 发布到技能商店 = 公有发布技能</div>
      <p class="text20 indent20">
          公有化发布技能是指供所有开发者账号使用的技能，一般情况下任何一个开发者在技能商店中看到您的技能都可以添加并使用。在技能发布页面选择“发布到技能商店”即为公有化发布功能。
      </p>
      <div class="sedTitle">Q：是否提供单独的ASR、NLU、TTS服务</div>
      <p class="text20 indent20">
          暂时不提供独立的服务。
      </p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
        font-size: 20px;
        color: #1e4d79;
        margin-bottom: 30px;
    }
    .sedTitle {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
        border-bottom: 1px solid #f3f3f3;
        margin-bottom: 15px;
        margin-top: 50px;
        &.fir {
            margin-top: 0px;
        }
    }
    .text20{
        padding-left:20px;
        display: block;
    }
    .indent20{
        text-indent: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/FAQ.vue